export default "__VITE_ASSET__Riv7X_sr__"